import emptySplitApi from "../utils/rtk";
import { CommonBody, Notifications } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetNotificationResponse = {
  length: number;
  start: number;
  response_object: Notifications[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const notificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationList: builder.mutation<
      CommonResponseType & { data: GetNotificationResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getNotifications,
        method: "POST",
        body,
      }),
    }),

    deleteNotification: builder.query<
      CommonResponseType & { data: Notifications },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteNotification}${id}/`,
        method: "DELETE",
      }),
    }),

    addNotification: builder.mutation<
      CommonResponseType & { data: Notifications },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addNotification,
        method: "POST",
        body,
      }),
    }),

    getAdminNotificationList: builder.mutation<
      CommonResponseType & { data: GetNotificationResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAdminNotification,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetNotificationListMutation,
  useLazyDeleteNotificationQuery,
  useAddNotificationMutation,
  useGetAdminNotificationListMutation
} = notificationApi;
